import { parse, stringify } from 'query-string';
import URL from 'url-parse';
import filterAndMapObject from 'utils/filterAndMapObject';

const URL_QUERY_PARAMETERS_WHITELIST = {
  cjevent: true,
  CJEVENT: true,
  dnr: true,
  dclid: true,
  ds_rl: true,
  fromSearchTerm: true,
  gclid: true,
  gclsrc: true,
  src: true,
  utm_source: true,
  utm_medium: true,
  utm_campaign: true,
  utm_term: true,
  utm_content: true,
  ULP_CAMPAIGN_ID: true,
  vreg: true,
};

export function getWhitelistedQuery(query) {
  return filterAndMapObject(query, parameter => URL_QUERY_PARAMETERS_WHITELIST[parameter]);
}

export function withWhitelistedQuery(pathname, query) {
  return {
    pathname,
    query: getWhitelistedQuery(query),
  };
}

export function filterQueryParametersAndReplace(pathname) {
  return (nextState, replace) => replace(withWhitelistedQuery(pathname, nextState.location.query));
}

export function stringToQuery(queryString) {
  return parse(queryString);
}

/*
  Wrapper for query stringifying method from from the query-string module. It does not encode commas into %2C.
  We should try to use it in all url stringifying areas which cannot be achieved using Url class from utils/url.
*/
export function queryToString(query, options = {}) {
  const queryString = stringify(query, options);
  return queryString.replace(/%2C/g, ',');
}

export function addQueryParams(u, params) {
  const url = new URL(u, true);
  url.set('query', Object.assign(url.query, params));
  return url.toString();
}
